import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

const SAAS_BYPASS_ROUTES = new Set([
  'saas_subscription_settings',
  'login',
  'no_accounts',
]);

const checkSaasSubscription = async (to, next) => {
  if (SAAS_BYPASS_ROUTES.has(to.name)) return next();

  const accountId = to.params?.accountId;
  if (!accountId) return next();

  const { isLoggedIn, getCurrentUser: user } = store.getters;
  if (!isLoggedIn) return next();

  const accountUser = user?.accounts?.find(
    a => String(a.id) === String(accountId)
  );
  if (!accountUser || accountUser.role !== 'administrator') return next();

  try {
    await store.dispatch('saasBilling/fetchSubscription');
  } catch {
    return next();
  }

  const isExpired = store.getters['saasBilling/isExpired'];
  const subscription = store.getters['saasBilling/getSubscription'];

  if (subscription && isExpired) {
    return next(
      frontendURL(`accounts/${accountId}/settings/saas-subscription`)
    );
  }

  return next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      const authNext = route => {
        if (route) return next(route);
        return checkSaasSubscription(to, next);
      };
      return validateAuthenticateRoutePermission(to, authNext, store);
    });
  });
};

export default router;
